var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g, _path12, _g2, _path13, _g3, _path14, _g4, _path15, _g5, _path16, _g6, _path17, _g7, _path18, _g8, _path19, _g9, _path20, _g10, _path21, _g11, _path22, _g12, _path23, _g13, _path24, _g14, _path25, _g15, _path26, _g16, _path27, _g17, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _g18, _path92, _g19, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _g20, _path167, _path168, _g21, _path169, _g22, _path170, _g23, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIdeaavatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 680,
    height: 680,
    viewBox: "0 0 680 680",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    width: 580,
    height: 530,
    fill: "#1A1A1A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 100,
    width: 530,
    height: 580,
    fill: "#1A1A1A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 630,
    y: 580,
    width: 50,
    height: 50,
    fill: "var(--color-primary)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 630,
    y: 630,
    width: 50,
    height: 50,
    fill: "url(#paint0_linear_1_1305)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 580,
    y: 630,
    width: 50,
    height: 50,
    fill: "var(--color-ternary)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 580,
    height: 580,
    transform: "translate(50 50)",
    fill: "#222222"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M103.268 305.404C101.577 339.173 105.918 373.676 117.32 405.029C135.428 454.817 174.352 498.476 224.858 514.472C242.298 519.995 260.614 522.183 278.859 523.525C322.667 526.747 366.76 525.242 410.411 520.333C442.975 516.67 476.054 510.867 504.713 494.976C542.475 474.035 559.054 438.66 568.379 398.305C572.477 380.567 576.116 362.628 576.922 344.44C579.082 295.748 559.529 246.167 523.565 213.27C496.393 188.417 460.115 173.702 423.328 172.418C380.477 170.923 340.472 187.225 298.343 192.062C264.706 195.924 230.748 191.525 196.915 190.217C186.595 189.818 176.075 189.731 166.171 192.669C135.526 201.76 112.784 239.391 107.367 269.52C105.258 281.265 103.875 293.287 103.268 305.404Z",
    fill: "#212121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M527.222 172.778L504.56 199.732L550.007 199.903L527.222 172.778Z",
    fill: "var(--color-ternary)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M527.522 194.018V289.473H335.44V360.65H152.467V393.204",
    stroke: "var(--color-ternary)",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M478.826 127.375H177.826V332.3H478.826V127.375Z",
    fill: "#1E1E1E",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M262.094 458.873H141V567.328H262.094V458.873Z",
    fill: "#161111"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M390.497 387.09H276.32V567.327H390.497V387.09Z",
    fill: "#161111"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M529.543 348.392H408.448V567.327H529.543V348.392Z",
    fill: "#161111"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M255.257 458.873H134.162V567.328H255.257V458.873Z",
    fill: "var(--color-primary)",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M383.661 387.09H269.484V567.327H383.661V387.09Z",
    fill: "var(--color-ternary)",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M522.705 348.392H401.611V567.327H522.705V348.392Z",
    fill: "var(--color-primary)",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.48
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_1305",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 134,
    y: 458,
    width: 122,
    height: 110
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M255.257 458.873H134.162V567.328H255.257V458.873Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_1305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.265 448.894V590.287",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.584 448.894V590.287",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.903 448.894V590.287",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.224 448.894V590.287",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.543 448.894V590.287",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.862 448.894V590.287",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.182 448.894V590.287",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1_1305",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 134,
    y: 458,
    width: 122,
    height: 110
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M255.257 458.873H134.162V567.328H255.257V458.873Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1_1305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.882 448.894V590.287",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.201 448.894V590.287",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.521 448.894V590.287",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.47
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1_1305",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 269,
    y: 387,
    width: 115,
    height: 181
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M383.661 387.09H269.484V567.327H383.661V387.09Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1_1305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M362.434 306.849L193.037 500.564",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.826 316.447L201.429 510.16",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.217 326.043L209.822 519.756",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.609 335.64L218.214 529.354",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.003 345.237L226.606 538.95",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.394 354.833L234.998 548.548",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.786 364.431L243.39 558.144",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.178 374.027L251.783 567.741",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.57 383.624L260.174 577.338",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.963 393.221L268.566 586.934",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.355 402.817L276.958 596.531",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.747 412.415L285.35 606.128",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.139 422.011L293.743 615.725",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.531 431.608L302.135 625.322",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.922 441.205L310.527 634.918",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.48
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1_1305",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 401,
    y: 348,
    width: 122,
    height: 220
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M522.705 348.392H401.611V567.327H522.705V348.392Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1_1305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M393.887 365.492H538.612",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1_1305",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 401,
    y: 348,
    width: 122,
    height: 220
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M522.705 348.392H401.611V567.327H522.705V348.392Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1_1305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M393.887 379.827H538.612",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1_1305",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 401,
    y: 348,
    width: 122,
    height: 220
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M522.705 348.392H401.611V567.327H522.705V348.392Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1_1305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M393.887 394.161H538.612",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_1_1305",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 401,
    y: 348,
    width: 122,
    height: 220
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M522.705 348.392H401.611V567.327H522.705V348.392Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_1_1305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M393.887 408.496H538.612",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_1_1305",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 401,
    y: 348,
    width: 122,
    height: 220
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M522.705 348.392H401.611V567.327H522.705V348.392Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_1_1305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M393.887 422.83H538.612",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_1_1305",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 401,
    y: 348,
    width: 122,
    height: 220
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M522.705 348.392H401.611V567.327H522.705V348.392Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_1_1305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M393.887 437.166H538.612",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_1_1305",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 401,
    y: 348,
    width: 122,
    height: 220
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M522.705 348.392H401.611V567.327H522.705V348.392Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_1_1305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M393.887 451.5H538.612",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_1_1305",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 401,
    y: 348,
    width: 122,
    height: 220
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M522.705 348.392H401.611V567.327H522.705V348.392Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_1_1305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M393.887 465.834H538.612",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_1_1305",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 401,
    y: 348,
    width: 122,
    height: 220
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M522.705 348.392H401.611V567.327H522.705V348.392Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_1_1305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M393.887 480.17H538.612",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_1_1305",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 401,
    y: 348,
    width: 122,
    height: 220
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M522.705 348.392H401.611V567.327H522.705V348.392Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_1_1305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M393.887 494.504H538.612",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_1_1305",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 401,
    y: 348,
    width: 122,
    height: 220
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M522.705 348.392H401.611V567.327H522.705V348.392Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_1_1305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M393.887 508.839H538.612",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_1_1305",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 401,
    y: 348,
    width: 122,
    height: 220
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M522.705 348.392H401.611V567.327H522.705V348.392Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_1_1305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M393.887 523.173H538.612",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_1_1305",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 401,
    y: 348,
    width: 122,
    height: 220
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M522.705 348.392H401.611V567.327H522.705V348.392Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_1_1305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M393.887 537.508H538.612",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_1_1305",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 401,
    y: 348,
    width: 122,
    height: 220
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M522.705 348.392H401.611V567.327H522.705V348.392Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_1_1305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M393.887 551.843H538.612",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M525.746 163.746C534.022 163.746 540.731 157.038 540.731 148.763C540.731 140.488 534.022 133.78 525.746 133.78C517.471 133.78 510.762 140.488 510.762 148.763C510.762 157.038 517.471 163.746 525.746 163.746Z",
    fill: "var(--color-primary)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M524.874 157.028C524.796 157.044 524.734 157.051 524.688 157.051C524.642 157.051 524.594 157.051 524.548 157.051C524.068 157.051 523.634 157.036 523.246 157.005C522.859 156.974 522.498 156.927 522.165 156.866C521.831 156.803 521.509 156.726 521.2 156.633C520.89 156.54 520.572 156.44 520.246 156.331C520.277 155.99 520.343 155.646 520.444 155.297C520.545 154.948 520.658 154.611 520.781 154.285C521.308 154.455 521.851 154.607 522.409 154.738C522.966 154.87 523.641 154.936 524.432 154.936C525.702 154.936 526.648 154.689 527.268 154.193C527.888 153.696 528.198 153.014 528.198 152.147C528.198 151.713 528.132 151.348 528 151.054C527.868 150.759 527.67 150.504 527.407 150.286C527.143 150.07 526.81 149.872 526.407 149.694C526.005 149.515 525.532 149.31 524.989 149.078L523.873 148.612C523.408 148.426 522.981 148.217 522.595 147.984C522.206 147.752 521.87 147.477 521.583 147.159C521.296 146.841 521.074 146.465 520.919 146.032C520.764 145.598 520.687 145.078 520.687 144.474C520.687 143.281 521.048 142.304 521.768 141.545C522.489 140.786 523.524 140.313 524.873 140.127V137.872C525.105 137.81 525.369 137.778 525.664 137.778C525.974 137.778 526.252 137.809 526.501 137.872V140.034C527.152 140.065 527.791 140.136 528.419 140.243C529.047 140.352 529.585 140.492 530.035 140.663C529.957 141.314 529.786 141.957 529.524 142.592C529.104 142.437 528.624 142.302 528.081 142.185C527.539 142.068 526.911 142.01 526.198 142.01C525.221 142.01 524.47 142.196 523.943 142.568C523.416 142.94 523.152 143.514 523.152 144.288C523.152 144.66 523.222 144.982 523.361 145.253C523.501 145.525 523.706 145.764 523.977 145.973C524.248 146.182 524.574 146.373 524.954 146.543C525.334 146.714 525.764 146.9 526.244 147.101L527.128 147.473C527.685 147.706 528.189 147.946 528.639 148.193C529.088 148.442 529.472 148.735 529.79 149.076C530.108 149.417 530.355 149.821 530.533 150.285C530.712 150.751 530.801 151.316 530.801 151.983C530.801 153.3 530.424 154.374 529.673 155.202C528.921 156.032 527.864 156.578 526.5 156.841V159.515C526.375 159.546 526.244 159.569 526.105 159.585C525.965 159.6 525.834 159.608 525.71 159.608C525.57 159.608 525.43 159.6 525.291 159.585C525.151 159.569 525.011 159.546 524.873 159.515L524.874 157.028Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M372.702 181.241L372.207 248.197L382.328 248.272L382.823 181.316L372.702 181.241Z",
    fill: "#161111"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M395.199 192.308L394.784 248.364L404.905 248.439L405.32 192.383L395.199 192.308Z",
    fill: "#161111"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M417.728 198.703L417.359 248.531L427.48 248.606L427.849 198.778L417.728 198.703Z",
    fill: "#161111"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M438.516 222.993L438.326 248.686L448.447 248.761L448.637 223.068L438.516 222.993Z",
    fill: "#161111"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M369.624 181.242L369.129 248.198L379.25 248.273L379.745 181.317L369.624 181.242Z",
    fill: "url(#paint1_linear_1_1305)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M392.12 192.309L391.705 248.365L401.826 248.44L402.241 192.384L392.12 192.309Z",
    fill: "var(--color-primary)",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M414.65 198.704L414.281 248.532L424.402 248.607L424.771 198.779L414.65 198.704Z",
    fill: "url(#paint2_linear_1_1305)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M435.438 222.993L435.248 248.686L445.369 248.76L445.559 223.068L435.438 222.993Z",
    fill: "var(--color-primary)",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M360.692 248.227L464.368 248.998",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M497.419 334.485L512.596 320.864L529.282 335.134L541.382 314.557L553.158 331.458L567.027 296.899L581.158 332.719",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M575.176 332.866C575.176 336.189 577.971 338.884 581.42 338.884C584.867 338.884 587.662 336.19 587.662 332.866C587.662 329.542 584.867 326.848 581.42 326.848C577.971 326.848 575.176 329.543 575.176 332.866Z",
    fill: "var(--color-primary)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M546.354 314.557C546.354 317.204 544.128 319.35 541.382 319.35C538.637 319.35 536.41 317.204 536.41 314.557C536.41 311.911 538.637 309.765 541.382 309.765C544.128 309.764 546.354 311.91 546.354 314.557Z",
    fill: "var(--color-primary)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M498.406 336.959C500.751 336.959 502.652 335.126 502.652 332.866C502.652 330.605 500.751 328.772 498.406 328.772C496.061 328.772 494.16 330.605 494.16 332.866C494.16 335.126 496.061 336.959 498.406 336.959Z",
    fill: "var(--color-second)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M513.247 324.798C515.489 324.798 517.306 323.046 517.306 320.885C517.306 318.724 515.489 316.973 513.247 316.973C511.006 316.973 509.188 318.724 509.188 320.885C509.188 323.046 511.006 324.798 513.247 324.798Z",
    fill: "var(--color-primary)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M562.986 296.568C562.986 299.158 565.165 301.258 567.852 301.258C570.54 301.258 572.719 299.158 572.719 296.568C572.719 293.977 570.54 291.877 567.852 291.877C565.164 291.877 562.986 293.977 562.986 296.568Z",
    fill: "var(--color-primary)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M548.573 332.866C548.573 330.564 550.509 328.698 552.897 328.698C555.285 328.698 557.221 330.563 557.221 332.866C557.221 335.168 555.285 337.034 552.897 337.034C550.509 337.034 548.573 335.168 548.573 332.866Z",
    fill: "var(--color-primary)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M527.974 337.697C530.742 337.697 532.986 335.534 532.986 332.866C532.986 330.198 530.742 328.035 527.974 328.035C525.206 328.035 522.962 330.198 522.962 332.866C522.962 335.534 525.206 337.697 527.974 337.697Z",
    fill: "var(--color-primary)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M207.134 157.655C207.134 161.821 203.757 165.198 199.592 165.198C195.426 165.198 192.049 161.821 192.049 157.655C192.049 153.489 195.426 150.112 199.592 150.112C203.757 150.112 207.134 153.489 207.134 157.655Z",
    fill: "#343434"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M207.134 189.154C207.134 193.319 203.757 196.696 199.592 196.696C195.426 196.696 192.049 193.319 192.049 189.154C192.049 184.988 195.426 181.611 199.592 181.611C203.757 181.611 207.134 184.988 207.134 189.154Z",
    fill: "#343434"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M348.582 151.854H218.618V154.889H348.582V151.854Z",
    fill: "#343434"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M314.931 158.682H218.618V161.717H314.931V158.682Z",
    fill: "#343434"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M329.435 183.351H218.618V186.386H329.435V183.351Z",
    fill: "#343434"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M308.549 190.18H218.618V193.215H308.549V190.18Z",
    fill: "#343434"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M294.059 197.829H218.618V200.864H294.059V197.829Z",
    fill: "#343434"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M201.303 151.699V159.995H200.299V152.752H200.25L198.225 154.097V153.076L200.299 151.699H201.303Z",
    fill: "#AFAFAF"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M197.515 191.88V191.151L200.253 188.153C200.575 187.802 200.839 187.497 201.047 187.238C201.255 186.976 201.409 186.73 201.509 186.5C201.612 186.268 201.663 186.025 201.663 185.771C201.663 185.48 201.593 185.227 201.452 185.014C201.315 184.8 201.126 184.636 200.885 184.519C200.645 184.403 200.375 184.345 200.075 184.345C199.757 184.345 199.478 184.411 199.241 184.544C199.006 184.673 198.823 184.856 198.694 185.091C198.567 185.326 198.503 185.601 198.503 185.917H197.547C197.547 185.431 197.66 185.004 197.884 184.637C198.108 184.27 198.413 183.983 198.799 183.778C199.188 183.573 199.624 183.47 200.108 183.47C200.594 183.47 201.024 183.573 201.4 183.778C201.775 183.983 202.07 184.26 202.283 184.609C202.496 184.957 202.603 185.345 202.603 185.771C202.603 186.076 202.548 186.375 202.437 186.666C202.329 186.955 202.14 187.278 201.87 187.635C201.602 187.988 201.231 188.42 200.756 188.931L198.892 190.924V190.989H202.749V191.88H197.515Z",
    fill: "#AFAFAF"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M207.134 305.44C207.134 309.606 203.757 312.983 199.592 312.983C195.426 312.983 192.049 309.606 192.049 305.44C192.049 301.274 195.426 297.897 199.592 297.897C203.757 297.897 207.134 301.274 207.134 305.44Z",
    fill: "#343434"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M335.818 299.639H218.618V302.674H335.818V299.639Z",
    fill: "#343434"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M306.807 306.466H218.618V309.501H306.807V306.466Z",
    fill: "#343434"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M197.321 306.466V305.639L200.966 299.871H201.566V301.151H201.161L198.406 305.51V305.574H203.316V306.466H197.321ZM201.226 308.167V306.214V305.83V299.871H202.182V308.167H201.226Z",
    fill: "#AFAFAF"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M184.889 333.795C186.927 332.139 188.387 329.792 189.905 327.706C191.483 325.535 193.042 322.945 196.087 322.921C199.31 322.895 201.468 324.784 204.091 326.215C206.869 327.731 209.106 329.315 210.259 332.431C211.678 336.264 210.327 340.368 207.916 343.516C206.31 345.614 204.266 347.333 202.166 348.936C196.568 353.207 190.128 356.875 183.096 357.251C180.327 357.398 177.555 357.028 174.836 356.487C171.848 355.893 168.67 354.941 166.853 352.497C166.469 351.982 166.153 351.396 166.06 350.759C165.972 350.162 166.084 349.554 166.231 348.968C167.627 343.409 172.257 339.002 177.624 336.992C179.678 336.223 181.868 335.751 183.74 334.61C184.143 334.364 184.524 334.09 184.889 333.795Z",
    fill: "black"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M210.364 370.586C210.35 368.506 210.15 366.431 210.136 364.354C208.467 362.536 206.523 360.971 204.242 359.788C204.232 359.783 204.224 359.776 204.215 359.771C202.796 359.936 199.789 360.684 198.761 359.282C197.743 357.894 198.35 354.856 198.454 353.243C199.23 353.165 200.007 353.087 200.784 353.009C201.502 352.936 202.227 352.863 202.91 352.628C207.249 351.14 208.369 346.532 208.728 342.462C209.046 338.853 208.971 335.435 207.969 331.943C207.484 330.253 206.747 328.543 205.357 327.465C203.066 325.685 199.739 325.965 197.019 326.069C194.627 326.16 192.348 326.999 190.444 328.446C186.623 331.347 184.527 336.151 183.606 340.741C182.617 345.67 184.097 350.729 182.598 355.463C182.219 356.661 181.688 357.86 180.748 358.695C179.982 359.376 179.004 359.763 178.036 360.102C176.783 360.541 175.585 360.809 174.392 360.958C171.953 363.639 169.67 366.481 167.018 368.944C167.026 368.947 167.035 368.951 167.042 368.955C179.925 374.393 194.097 376.526 208.067 375.889C208.778 375.857 209.563 375.811 210.357 375.723C210.35 374.011 210.375 372.299 210.364 370.586Z",
    fill: "#EBEBEB",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M151.461 404.098C152.614 412.291 152.957 426.366 161.031 431.129C163.901 432.822 167.343 433.159 170.661 433.459C185.213 434.771 200.933 435.827 213.366 428.151C215.075 427.096 216.71 425.871 217.96 424.3C220.361 421.285 221.124 417.32 221.762 413.52C223.372 403.917 224.335 395.644 222.578 386.017C221.25 378.742 219.384 371.424 215.496 365.133C212.739 360.67 207.722 359.178 202.598 359.192C201.573 361.923 199.919 364.499 197.511 366.147C194.203 368.412 189.364 368.061 185.603 366.993C183.611 366.428 181.709 365.475 180.116 364.145C179.706 363.802 176.774 359.867 176.798 359.863C171.602 360.896 166.312 361.963 161.668 364.513C154.144 368.644 150.445 377.099 149.776 385.361C149.254 391.832 150.57 397.762 151.461 404.098Z",
    fill: "var(--color-ternary)",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M233.289 467.463C231.882 465.825 229.999 464.558 228.174 463.354C222.074 459.334 214.297 454.547 206.617 454.99C202.064 455.253 195.741 458.342 194.799 463.161C194.692 463.704 194.647 464.287 194.865 464.797C195.407 466.063 197.118 466.177 198.495 466.189C209.584 466.287 219.641 472.539 230.514 474.72C231.695 474.956 233.017 475.12 234.023 474.456C235.552 473.445 235.455 471.113 234.637 469.472C234.274 468.74 233.815 468.076 233.289 467.463Z",
    fill: "black"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M258.514 419.215C256.139 416.585 252.757 414.882 249.287 414.232C244.42 413.32 239.392 414.203 234.616 415.519C224.5 418.305 215.013 423.001 204.844 425.613C200.335 426.772 197.395 426.343 192.987 425.987C187.399 425.536 181.662 426.086 176.039 425.754C170.783 425.443 165.096 425.036 160.185 426.485C159.536 426.058 158.89 425.631 158.246 425.209C152.75 421.604 147.276 418.013 140.386 419.327C134.969 420.36 129.744 423.106 126.387 427.566C122.822 432.304 123.893 438.49 127.087 443.214C129.731 447.125 133.641 450.004 137.689 452.432C151.654 460.81 166.909 465.945 183.389 464.8C185.596 464.647 188.196 464.622 189.785 466.394C190.382 467.059 190.729 470.71 192.055 470.553C193.687 470.359 196.83 469.903 198.373 469.345C206.701 466.336 215.028 463.328 223.356 460.321C230.673 457.677 238.043 455.009 244.709 450.998C250.474 447.53 255.696 442.838 258.757 436.76C260.964 432.377 262.776 426.603 260.472 422.052C259.944 421.012 259.282 420.065 258.514 419.215Z",
    fill: "#0D0D0D",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M155.151 431.809C159.833 434.148 164.735 435.644 169.219 438.416C173.703 441.187 177.943 444.416 182.812 446.51C185.97 447.869 189.573 448.455 192.601 449.959",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M189.585 465.761C188.837 464.059 187.915 462.391 187.133 460.77C186.612 459.692 186.27 458.578 185.699 457.517C185.618 457.365 185.527 457.204 185.37 457.132C185.236 457.07 185.081 457.085 184.935 457.103C182.721 457.366 180.507 457.629 178.293 457.892C176.672 458.084 174.339 457.917 173.125 459.164C172.448 459.861 172.042 460.769 171.589 461.63C168.224 468.008 161.863 472.208 157.457 477.917C156.543 479.102 155.681 480.449 155.67 481.945C155.661 483.407 156.556 484.838 157.875 485.468C161.37 487.137 166.628 483.127 169.353 481.343C173.353 478.724 177.076 475.71 180.716 472.619C183.253 470.465 187.294 468.896 190.545 468.365C190.296 467.49 189.963 466.621 189.585 465.761Z",
    fill: "black"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M201.411 432.772C203.912 432.444 212.571 431.624 212.34 427.696C212.296 426.944 211.719 426.334 211.105 425.897C209.113 424.479 206.551 424.21 204.117 423.978C194.787 423.086 185.587 421.956 176.435 419.931C175.449 419.713 174.437 419.467 173.62 418.87C172.578 418.108 171.997 416.883 171.458 415.709C170.183 412.934 168.908 410.157 167.633 407.381C166.981 405.961 166.316 404.521 165.298 403.336C162.214 399.751 157.134 400.118 154.314 403.815C153.084 405.427 152.43 407.414 152.09 409.413C151.19 414.701 152.439 420.325 155.493 424.734C158.548 429.144 163.374 432.29 168.642 433.306C172.417 434.034 176.301 433.703 180.143 433.571C186.307 433.358 192.492 433.65 198.641 433.077C199.117 433.034 200.137 432.939 201.411 432.772Z",
    fill: "#EBEBEB",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M208.543 404.928C208.504 407.035 207.624 409.099 206.594 410.943C205.189 413.458 203.449 415.88 201.531 418.029C199.154 420.692 196.335 423.165 193.314 425.073C191.546 426.19 189.653 427.081 187.813 428.062C187.771 428.115 187.725 428.162 187.684 428.216C187.093 428.98 186.51 429.896 186.697 430.844C186.92 431.972 188.134 432.611 189.258 432.855C192.239 433.498 196.673 433.142 199.621 432.408C210.903 429.601 219.972 423.601 222.491 409.196C217.618 408.752 213.148 406.603 208.543 404.928Z",
    fill: "#EBEBEB",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M206.946 377.065C207.309 384.204 208.868 391.23 209.013 398.381C209.164 405.793 207.103 413.46 203.733 420.021",
    fill: "var(--color-ternary)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M206.946 377.065C207.309 384.204 208.868 391.23 209.013 398.381C209.164 405.793 207.103 413.46 203.733 420.021",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M166.379 437.016H215.944C216.67 437.016 217.258 436.427 217.258 435.701C217.258 434.975 216.67 434.387 215.944 434.387H166.379C165.653 434.387 165.064 434.975 165.064 435.701C165.066 436.427 165.654 437.016 166.379 437.016Z",
    fill: "black"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M173.732 435.233H217.112L226.122 412.982C226.416 412.257 225.882 411.466 225.1 411.466H184.099C183.65 411.466 183.246 411.738 183.078 412.155L173.732 435.233Z",
    fill: "black"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M199.651 322.469C200.047 322.56 200.44 322.671 200.826 322.803C204.473 324.058 207.598 328.145 208.892 331.659C209.09 332.197 209.266 332.747 209.331 333.317C209.414 334.065 209.299 334.834 209 335.523C208.077 334.807 207.263 333.95 206.597 332.99C206.79 333.268 201.048 337.983 200.311 338.41C197.89 339.811 195.097 340.399 192.313 340.27C191.763 340.245 190.182 339.806 189.782 340.141C189.44 340.428 189.554 342.286 189.481 342.712C189.124 344.811 188.456 347.147 187.759 349.141C186.902 351.591 184.09 351.828 181.872 351.82C178.124 351.806 174.328 351.697 170.73 350.649C168.292 349.94 165.776 348.591 164.881 346.216C164.204 344.423 164.599 342.396 165.313 340.617C166.197 338.416 167.598 336.368 169.567 335.047C171.506 333.746 173.875 333.223 176.205 333.096C177.016 333.052 177.861 333.044 178.589 332.684C179.747 332.111 180.312 330.815 180.972 329.704C183.559 325.351 188.637 322.982 193.658 322.317C195.647 322.051 197.702 322.02 199.651 322.469Z",
    fill: "black"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M235.827 423.695C226.452 427.934 218.907 435.3 210.371 441.045C202.4 446.411 193.573 450.352 184.797 454.266C185.256 455.273 185.442 456.265 185.901 457.27",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M189.674 346.802C186.115 346.232 186.034 341.418 188.194 339.339C189.173 338.396 190.563 337.801 191.899 338.04C193.237 338.279 194.415 339.496 194.351 340.854",
    fill: "#EBEBEB"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M189.674 346.802C186.115 346.232 186.034 341.418 188.194 339.339C189.173 338.396 190.563 337.801 191.899 338.04C193.237 338.279 194.415 339.496 194.351 340.854",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M201.792 345.005C202.351 346.834 204.587 347.945 206.383 347.287",
    stroke: "#212121",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M190.852 340.246C191.53 340.336 192.151 340.774 192.464 341.382C192.776 341.99 192.769 342.751 192.446 343.354",
    stroke: "#212121",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M153.494 373.312C149.312 380.057 149.339 387.788 148.937 395.392C148.501 403.667 149.443 412.012 151.713 419.982C152.38 419.845 153.046 419.685 153.712 419.53C156.327 418.482 160.858 417.001 161.577 416.779C165.212 415.655 168.709 414.084 171.956 412.101C171.304 406.649 170.846 401.099 169.844 395.722C168.886 390.584 168.699 385.091 169.985 379.965",
    fill: "var(--color-ternary)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M153.494 373.312C149.312 380.057 149.339 387.788 148.937 395.392C148.501 403.667 149.443 412.012 151.713 419.982C152.38 419.845 153.046 419.685 153.712 419.53C156.327 418.482 160.858 417.001 161.577 416.779C165.212 415.655 168.709 414.084 171.956 412.101C171.304 406.649 170.846 401.099 169.844 395.722C168.886 390.584 168.699 385.091 169.985 379.965",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M204.493 423.364C204.032 424.57 202.475 425.546 201.018 425.546C199.56 425.546 198.752 424.57 199.214 423.364C199.675 422.158 201.23 421.182 202.689 421.182C204.146 421.182 204.954 422.16 204.493 423.364Z",
    stroke: "#EBEBEB",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M153.626 182.063C153.569 172.113 145.19 164.157 135.125 164.758C126.635 165.265 119.607 172.044 118.831 180.513C118.273 186.614 120.857 192.124 125.141 195.636C127.768 197.789 129.539 200.806 129.911 204.182L130.945 213.575L141.793 213.513L142.72 204.106C143.051 200.746 144.757 197.706 147.351 195.544C151.21 192.327 153.656 187.48 153.626 182.063Z",
    fill: "var(--color-primary)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M136.382 215.87C132.601 215.891 129.52 212.844 129.498 209.064L129.481 206.094L143.171 206.016L143.187 208.987C143.208 212.766 140.161 215.848 136.382 215.87Z",
    fill: "black"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M133.693 207.533C132.783 203.288 131.873 199.042 130.963 194.797C130.121 190.865 128.345 186.764 127.991 182.807C127.809 180.777 130.001 180.45 131.142 181.695C131.985 182.617 132.259 184.322 132.209 185.528C132.27 184.102 132.651 182.692 133.316 181.429C133.451 181.174 133.608 180.913 133.859 180.77C134.259 180.541 134.794 180.692 135.121 181.016C135.449 181.341 135.605 181.799 135.704 182.248C135.97 183.463 135.879 184.752 135.448 185.917C135.919 184.527 136.519 183.179 137.239 181.9C137.657 181.157 138.415 180.327 139.205 180.649C139.752 180.872 139.95 181.541 140.01 182.13C140.126 183.299 139.959 184.495 139.528 185.588C139.763 184.144 140.299 182.748 141.091 181.517C141.471 180.928 142.053 180.315 142.743 180.426C143.221 180.503 143.584 180.925 143.732 181.386C144.318 183.191 143.578 185.27 143.244 187.085C142.732 189.864 142.22 192.642 141.708 195.421C140.988 199.333 140.266 203.244 139.546 207.156",
    stroke: "#212121",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M109.364 177.672C112.513 178.11 111.494 177.968 114.697 178.414",
    stroke: "#212121",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M114.054 164.698L118.136 168.409",
    stroke: "#212121",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M130.919 156.295C131.185 157.661 131.455 159.915 131.72 161.281",
    stroke: "#212121",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M142.358 155.813C141.972 158.748 141.708 160.761 141.551 161.954",
    stroke: "#212121",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M158.835 167.595C156.132 169.489 156.316 169.36 153.534 171.31",
    stroke: "#212121",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M157.675 179.606C160.939 179.82 160.127 179.767 163.408 179.983",
    stroke: "#212121",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_1_1305",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 129,
    y: 206,
    width: 15,
    height: 10
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M136.382 215.87C132.601 215.891 129.52 212.844 129.498 209.064L129.481 206.094L143.171 206.016L143.187 208.987C143.208 212.766 140.161 215.848 136.382 215.87Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_1_1305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.95 209.459L144.739 209.365",
    stroke: "#E0ADAD",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_1_1305",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 129,
    y: 206,
    width: 15,
    height: 10
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M136.382 215.87C132.601 215.891 129.52 212.844 129.498 209.064L129.481 206.094L143.171 206.016L143.187 208.987C143.208 212.766 140.161 215.848 136.382 215.87Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_1_1305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.969 212.817L144.758 212.723",
    stroke: "#E0ADAD",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M444.507 187.771C433.776 187.771 425.045 179.04 425.045 168.309C425.045 157.577 433.776 148.848 444.507 148.848C455.239 148.848 463.97 157.578 463.97 168.309C463.97 179.04 455.239 187.771 444.507 187.771ZM444.507 159.211C439.49 159.211 435.409 163.292 435.409 168.309C435.409 173.326 439.49 177.407 444.507 177.407C449.524 177.407 453.605 173.326 453.605 168.309C453.605 163.292 449.524 159.211 444.507 159.211Z",
    fill: "var(--color-ternary)",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M425.539 172.66C425.212 171.235 425.046 169.771 425.046 168.309C425.046 157.577 433.777 148.848 444.508 148.848C455.24 148.848 463.97 157.578 463.97 168.309H453.606C453.606 163.378 449.439 159.211 444.508 159.211C439.577 159.211 435.41 163.378 435.41 168.309C435.41 168.993 435.487 169.677 435.64 170.344L425.539 172.66Z",
    fill: "var(--color-primary)",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M463.97 168.309H453.606C453.606 163.378 449.439 159.211 444.507 159.211C442.608 159.211 440.785 159.793 439.236 160.893L433.232 152.446C436.545 150.092 440.444 148.847 444.507 148.847C455.239 148.847 463.97 157.577 463.97 168.309Z",
    fill: "#EBEBEB",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M452.593 164.228C453.233 165.464 453.605 166.851 453.605 168.309H463.969C463.969 163.818 462.426 159.689 459.861 156.393C457.376 158.946 454.942 161.546 452.593 164.228Z",
    fill: "var(--color-primary)",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M102.853 294.857C102.774 289.499 107.405 285.361 112.48 285.603C114.245 285.688 115.863 286.272 117.221 287.201C119.335 284.785 122.49 283.318 125.946 283.483C130.69 283.71 135.279 286.918 135.663 291.315C140.306 292.641 143.806 296.945 143.565 301.978C143.417 305.086 141.948 307.82 139.727 309.661C140.289 311.256 140.235 313.133 139.211 315.002C138.662 316.003 137.797 316.814 136.764 317.301C134.872 318.192 133.086 318.148 131.579 317.559L131.46 326.245C131.452 326.766 130.781 326.971 130.484 326.542L125.941 319.985C121.707 321.717 117.909 319.118 117.625 315.272C116.5 315.832 115.225 316.128 113.88 316.063C109.997 315.877 106.938 312.821 106.64 309.045C104.518 310.309 101.749 310.576 98.9997 309.199C97.4762 308.437 96.2794 307.115 95.6766 305.521C93.5481 299.895 97.6742 294.778 102.853 294.857Z",
    fill: "var(--color-ternary)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M134.126 305.488C136.63 305.608 138.718 307.183 139.615 309.356",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M106.699 308.41C106.9 304.198 110.478 300.946 114.69 301.147",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M102.202 294.865C103.812 294.759 105.314 295.143 106.58 295.882",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M110.874 289.011C114.258 289.172 116.869 292.047 116.707 295.429",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M116.245 312.329C113.261 312.611 110.612 310.421 110.33 307.437",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1613 304.38C98.278 301.831 99.6277 299.048 102.176 298.164",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M136.468 311.539C135.836 313.487 133.745 314.553 131.798 313.922",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M127.55 292.815C129.801 291.266 132.632 290.701 135.522 291.288",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M137.256 295.993C138.767 297.111 139.758 298.896 139.791 300.92",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M120.871 298.336C122.756 297.958 124.831 298.857 125.844 300.49C126.858 302.124 126.743 304.382 125.567 305.904",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M120.236 307.614C119.578 308.211 119.244 309.144 119.372 310.024C119.499 310.903 120.085 311.702 120.885 312.089",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M280.317 234.723C280.278 236.787 279.548 238.868 277.961 240.731C275.474 243.649 271.715 245.2 267.957 245.957C260.771 247.404 253.209 247.765 246.379 244.714C243.522 243.438 240.578 241.302 238.868 238.651C235.425 233.309 239.255 227.361 244.131 224.575C250.4 220.992 259.168 220.85 266.108 222.022C269.032 222.516 271.944 223.341 274.473 224.892C278.083 227.105 280.392 230.886 280.317 234.723Z",
    fill: "var(--color-primary)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M235.977 268.938C236.007 269.346 236.004 269.758 235.966 270.171C235.422 276.186 227.368 278.51 222.354 278.51C217.739 278.51 212.222 276.926 209.579 272.828C206.848 268.59 209.48 263.827 213.432 261.455C215.996 259.916 219.034 259.31 222.024 259.256C225.359 259.195 228.803 259.834 231.562 261.709C233.977 263.35 235.77 266.059 235.977 268.938Z",
    fill: "var(--color-primary)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M273.563 268.885C273.572 269.097 273.57 269.311 273.556 269.528C273.396 272.172 271.545 274.486 269.279 275.86C265.507 278.147 260.748 279.047 256.406 278.331C252.293 277.652 245.172 274.826 245.058 269.819C244.955 265.323 249.969 261.479 253.726 260.006C260.296 257.432 273.2 260.036 273.563 268.885Z",
    fill: "var(--color-ternary)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M309.696 268.915C309.79 270.319 309.517 271.718 308.789 272.943C307.786 274.63 306.091 275.791 304.335 276.665C301.611 278.02 298.826 278.51 295.809 278.51C291.3 278.51 286.022 277.015 283.271 273.172C280.49 269.287 283.039 264.195 286.641 261.785C289.445 259.909 292.923 259.271 296.296 259.307C300.039 259.346 303.947 260.255 306.711 262.78C308.421 264.345 309.543 266.634 309.696 268.915Z",
    fill: "var(--color-primary)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M242.081 247.345C239.996 248.686 230.761 255.239 230.761 255.239",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M259.455 249.583C259.605 251.519 259.755 253.455 259.906 255.391",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M277.829 247.047C280.071 248.647 286.53 254.411 288.553 256.282",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M245.983 234.351C246.842 235.481 248.408 236.018 249.78 235.653C251.152 235.289 252.244 234.044 252.429 232.637C252.494 232.139 252.212 231.438 251.732 231.584C251.598 231.625 251.494 231.727 251.406 231.835C250.618 232.794 250.825 234.351 251.728 235.202C252.631 236.054 254.057 236.215 255.211 235.76C256.366 235.304 257.254 234.311 257.775 233.186C257.915 232.883 258.032 232.539 257.925 232.223C257.695 231.551 256.575 231.65 256.247 232.281C255.919 232.911 256.196 233.699 256.634 234.257C257.523 235.393 259.084 235.957 260.493 235.653C261.902 235.35 263.092 234.192 263.436 232.792C263.518 232.453 263.547 232.066 263.34 231.785C262.989 231.306 262.151 231.492 261.856 232.008C261.561 232.523 261.682 233.18 261.927 233.721C262.738 235.501 264.916 236.533 266.807 236.033C268.016 235.713 268.923 234.7 269.318 233.542C269.457 233.134 269.635 232.361 269.168 232.094C268.301 231.596 268.212 232.883 268.294 233.385C268.41 234.081 268.834 234.851 269.423 235.256C270.743 236.166 272.821 235.611 273.512 234.165",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M215.134 270.136C215.331 268.604 216.92 267.674 218.391 267.202C218.7 267.103 219.026 267.012 219.346 267.064C220.225 267.204 220.594 268.297 220.517 269.183C220.48 269.597 220.376 270.029 220.083 270.324C219.791 270.619 219.267 270.711 218.962 270.428C218.659 270.146 218.702 269.647 218.864 269.265C219.269 268.311 220.209 267.693 221.161 267.286C222 266.927 222.964 266.69 223.817 267.014C224.566 267.299 225.127 268.026 225.212 268.824C225.297 269.621 224.903 270.45 224.23 270.887C224.131 270.951 224.021 271.009 223.903 271.006C223.781 271.003 223.669 270.933 223.578 270.852C223.043 270.375 223.072 269.485 223.457 268.881C223.842 268.276 224.489 267.895 225.122 267.561C225.823 267.191 226.57 266.842 227.361 266.846C228.153 266.849 228.996 267.304 229.2 268.069",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M251.932 267.05C251.792 267.214 251.652 267.379 251.548 267.568C251.01 268.542 251.68 269.862 252.708 270.285C253.737 270.708 254.94 270.409 255.891 269.83C256.872 269.232 257.731 268.036 257.246 266.994C257.209 266.915 257.161 266.836 257.083 266.797C256.942 266.728 256.776 266.825 256.663 266.934C255.834 267.726 256.104 269.243 257.013 269.942C257.921 270.641 259.219 270.634 260.292 270.228C261.037 269.947 261.728 269.477 262.176 268.818C262.422 268.456 262.718 268.066 262.72 267.608C262.722 267.323 262.583 267.023 262.327 266.898C261.174 266.342 261.331 269.093 261.685 269.612C262.382 270.634 263.805 270.968 265.005 270.669",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M288.538 267.597C288.483 268.621 288.869 269.682 289.635 270.363C290.402 271.045 291.55 271.3 292.505 270.923C293.459 270.545 294.136 269.511 294.017 268.493C293.982 268.193 293.855 267.868 293.576 267.752C293.288 267.632 292.939 267.8 292.776 268.066C292.612 268.332 292.602 268.665 292.653 268.973C292.884 270.356 294.362 271.356 295.752 271.185C297.144 271.016 298.299 269.806 298.546 268.426C298.577 268.252 298.595 268.068 298.533 267.903C298.379 267.494 297.771 267.416 297.427 267.686C297.084 267.957 296.982 268.443 297.03 268.878C297.168 270.103 298.464 271.069 299.677 270.849C300.89 270.629 301.766 269.27 301.463 268.075C301.434 267.959 301.394 267.841 301.317 267.751C301.104 267.5 300.67 267.549 300.439 267.785C300.209 268.021 300.149 268.377 300.168 268.706C300.216 269.539 300.737 270.327 301.483 270.699C302.229 271.071 303.173 271.012 303.867 270.55",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M355.438 564.64C355.546 564.987 355.666 565.353 355.944 565.617C356.258 565.914 356.711 566.028 357.139 566.126C360.844 566.978 364.585 567.646 368.34 568.127C367.151 558.588 367.538 548.789 363.743 539.672C363.183 538.326 362.514 536.975 361.433 535.905C359.649 534.137 356.879 533.358 354.39 533.657C352.416 533.895 348.503 535.287 347.958 537.258C347.363 539.412 349.581 544.092 350.177 546.344C351.797 552.465 353.552 558.566 355.438 564.64Z",
    fill: "#EBEBEB",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M383.023 576.83C379.073 576.354 375.116 575.931 371.152 575.565C367.806 575.256 364.446 575.083 361.115 574.637C358.753 574.321 356.306 573.89 354.046 573.036C352.617 572.496 353.533 569.1 353.74 568.152C354.233 565.896 354.212 563.425 354.117 561.129C357.923 561.066 361.734 560.999 365.53 560.852C366.235 560.825 366.961 560.801 367.626 561.035C368.511 561.346 369.174 562.068 369.861 562.706C372.639 565.293 389.784 571.048 388.829 575.837C388.567 577.15 386.765 577.297 385.438 577.129C384.634 577.027 383.828 576.927 383.023 576.83Z",
    fill: "#161111"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M307.949 566.105C307.908 566.449 307.86 566.81 307.631 567.068C307.375 567.358 306.941 567.463 306.53 567.552C302.977 568.33 299.351 568.924 295.674 569.33C295.011 559.852 292.715 550.088 294.749 541.081C295.049 539.751 295.458 538.419 296.335 537.373C297.782 535.646 300.412 534.924 302.968 535.27C304.997 535.544 309.196 537.007 310.126 538.979C311.143 541.136 309.828 545.754 309.668 547.985C309.235 554.05 308.661 560.091 307.949 566.105Z",
    fill: "#EBEBEB",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M309.255 295.848C309.302 296.176 309.351 296.505 309.405 296.832C310.231 301.906 308.272 307.202 309.283 312.453C309.999 316.171 313.167 323.566 317.733 324.05C318.896 324.173 320.061 322.632 320.701 321.846C322.82 319.245 324.523 316.183 324.887 312.849C325.063 311.236 324.923 309.607 324.782 307.99C324.58 305.665 324.378 303.339 324.176 301.013C324.081 299.922 323.986 298.826 323.758 297.755C323.347 295.82 322.489 293.964 321.174 292.487C318.459 289.433 314.498 289.189 310.661 289.117C310.228 289.11 309.767 289.12 309.402 289.354C308.699 289.806 308.696 290.814 308.773 291.645C308.904 293.056 309.054 294.457 309.255 295.848Z",
    fill: "#EBEBEB",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M318.205 300.968C315.783 301.697 309.458 302.682 309.458 302.682C309.513 301.439 309.704 299.148 309.594 297.909C309.579 297.743 309.431 296.682 309.285 295.743C309.159 294.941 309.034 294.227 308.993 294.238C309.549 294.092 310.139 293.829 310.573 293.443C310.84 293.205 311.025 292.888 311.297 292.64C313.022 291.059 315.565 290.697 317.717 291.552C318.977 292.052 320.053 292.931 320.88 293.996C321.377 294.635 321.786 295.34 322.121 296.077C322.471 296.852 322.942 297.857 322.995 298.714C322.996 298.723 323.026 298.945 323.074 299.315C321.467 299.914 319.847 300.473 318.205 300.968Z",
    fill: "black"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M325.999 285.691C326.992 282.611 330.418 283.878 331.166 286.413C331.55 287.712 331.195 289.203 330.269 290.192C329.594 290.914 328.544 291.369 327.6 291.078",
    fill: "#EBEBEB"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M325.999 285.691C326.992 282.611 330.418 283.878 331.166 286.413C331.55 287.712 331.195 289.203 330.269 290.192C329.594 290.914 328.544 291.369 327.6 291.078",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M325.489 274.803C323.562 273.775 318.348 277.45 316.168 277.724C314.025 278.2 310.681 278.742 309.17 280.321C305.973 283.663 306.564 289.469 308.578 293.542C308.916 294.224 309.616 295.961 310.021 296.604C313.25 301.742 319.234 302.198 322.238 301.473C325.826 300.606 327.775 297.612 328.382 293.421C328.491 292.668 328.518 290.213 328.53 289.452C328.602 284.781 327.517 275.886 325.489 274.803Z",
    fill: "#EBEBEB",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M324.792 271.96C322.784 270.754 320.442 270.19 318.006 269.889C316.275 269.676 314.509 269.556 312.795 269.876C310.441 270.316 308.255 271.606 306.734 273.457C304.585 276.068 303.948 279.618 304.527 282.886C304.937 285.206 305.815 288.836 308.244 289.875C309.731 290.511 310.718 289.943 310.969 288.385C311.26 286.575 310.931 284.643 311.138 282.791C311.165 282.548 311.201 282.289 311.366 282.107C311.553 281.902 311.851 281.855 312.125 281.814C316.252 281.206 319.813 279.298 323.106 276.798C323.776 277.659 324.769 278.259 325.843 278.453C326.433 278.558 327.36 278.631 327.902 278.352C328.504 278.043 328.792 277.302 328.731 276.628C328.67 275.954 328.321 275.339 327.918 274.795C327.02 273.583 325.963 272.662 324.792 271.96Z",
    fill: "black"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M323.787 274.879C325.538 273.548 327.846 275.261 328.512 276.875C329.289 278.758 329.108 280.962 328.987 282.946C328.916 284.108 328.982 285.484 328.831 286.702C328.748 285.966 328.654 285.232 328.53 284.503C328.303 283.18 327.964 281.388 327.116 280.11C326.881 279.375 326.456 278.683 325.786 278.313C325.296 278.043 324.717 277.959 324.239 277.669C323.821 277.415 323.501 277.003 323.355 276.536C323.176 275.954 323.303 275.246 323.787 274.879Z",
    fill: "black"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M310.19 291.918C309.228 293.304 307.567 293.49 306.374 292.327C303.948 289.965 304.963 283.898 309.257 285.119C310.427 285.451 311.165 286.572 311.8 287.611",
    fill: "#EBEBEB"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M310.19 291.918C309.228 293.304 307.567 293.49 306.374 292.327C303.948 289.965 304.963 283.898 309.257 285.119C310.427 285.451 311.165 286.572 311.8 287.611",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M287.149 453.321C286.738 438.503 286.428 424.194 288.77 409.467C289.774 403.153 294.99 381.376 302.907 380.192C303.39 380.119 303.767 380.161 304.109 380.242C304.524 378.027 305.372 375.946 306.557 374.042C310.009 368.492 316.276 364.442 322.688 362.924C329.801 361.24 338.472 362.207 341.6 370.405C343.202 374.604 342.83 378.874 344.74 382.934C350.134 394.403 350.826 405.789 352.432 418.418C354.328 433.336 356.3 448.244 358.345 463.142C362.231 491.45 366.392 519.721 370.812 547.951C367.874 548.658 364.902 549.213 361.896 549.553C356.674 550.144 351.427 549.997 346.218 549.388C341.128 523.719 335.692 498.118 329.895 472.6C326.995 459.829 324.824 453.326 321.826 441.199C321.506 444.309 321.171 447.416 320.821 450.521C319.583 461.529 318.626 472.567 317.036 483.532C313.811 505.782 312.819 528.481 313.705 551.07C308.782 551.27 299.049 550.892 294.333 550.557C293.628 550.506 288.383 549.814 288.324 549.154C286.719 531.367 286.781 517.07 286.409 498.392C286.131 484.352 287.531 467.09 287.149 453.321Z",
    fill: "#0D0D0D",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M317.071 292.946C317.212 294.042 318.814 294.87 320.761 294.814L317.071 292.946Z",
    fill: "#EBEBEB"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M317.071 292.946C317.212 294.042 318.814 294.87 320.761 294.814",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M278.402 319.887C278.973 318.801 279.658 317.758 280.474 316.764C284.787 311.511 291.222 309.464 297.77 308.814C301.49 308.444 305.268 308.754 308.864 307.6C308.969 308.647 309.116 309.705 309.53 310.672C310.81 313.667 314.518 314.354 317.734 314.328C320.991 314.303 324.43 311.562 324.683 307.948C328.372 308.558 332.158 308.339 335.848 308.939C338.769 309.415 341.789 310.509 343.89 312.673C346.26 315.113 348.354 318.075 350.1 320.992C350.589 321.809 351.062 322.637 351.528 323.463C358.486 335.803 362.01 348.557 357.687 362.313C356.762 365.258 355.502 368.381 352.849 369.959C351.691 370.647 350.351 370.951 349.001 370.944C349.915 379.188 351.077 387.743 351.149 394.928C341.281 398.703 296.374 401.651 289.995 398.721C291.712 390.981 292.261 380.63 292.052 370.077C290.038 368.765 288.421 366.829 287.017 364.843C282.372 358.268 278.753 350.801 276.97 342.928C275.876 338.098 275.495 333.038 276.038 328.108C276.359 325.178 277.072 322.416 278.402 319.887Z",
    fill: "var(--color-primary)",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M343.928 361.047C339.445 361.978 334.925 362.846 330.466 363.993C323.869 365.69 317.272 367.387 310.676 369.083C307.039 370.018 303.365 370.96 299.611 371.051C295.173 371.159 288.186 370.157 288.374 364.281C288.588 357.59 294.33 352.024 300.329 349.948C305.992 347.987 312.148 348.224 318.135 348.483C323.988 348.738 329.837 349.084 335.684 349.432C340.568 349.722 345.703 349.164 350.527 349.767C354.059 350.208 357.329 352.22 359.472 355.061C361.557 357.827 365.272 367.463 359.418 368.731C356.905 369.274 357.252 366.903 356.711 365.302C355.915 362.953 354.507 361.528 352.12 360.842C349.801 360.175 346.769 360.456 343.928 361.047Z",
    fill: "#EBEBEB",
    stroke: "#212121",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M326.965 365.871C327.478 366.215 327.995 366.553 328.518 366.879C330.327 368.005 332.222 368.743 334.135 369.64C340.178 372.47 346.369 372.213 352.65 370.61C359.134 368.954 357.598 361.82 353.879 357.931C351.381 355.32 347.999 353.746 344.607 352.498C336.559 349.538 328.15 348.922 319.939 346.75C312.414 344.759 303.681 342.849 296.433 346.779C294.947 347.586 293.744 348.861 292.929 350.334C292.501 351.108 292.1 351.923 291.875 352.782C291.715 353.389 291.687 353.92 291.712 354.534C291.731 354.982 291.905 355.421 291.755 355.857C292.839 354.96 293.451 354.182 294.743 353.513C296.274 352.718 297.804 351.924 299.334 351.13C299.494 351.047 299.661 350.963 299.841 350.965C299.994 350.967 300.138 351.033 300.278 351.098C308.112 354.743 315.984 358.41 323.146 363.245C324.425 364.109 325.682 365.01 326.965 365.871Z",
    fill: "#EBEBEB",
    stroke: "#212121",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M309.91 575.595C309.821 575.621 309.723 575.637 309.626 575.654C308.864 575.664 308.104 575.687 307.343 575.718C307.148 575.72 306.957 575.728 306.769 575.743C305.86 575.785 304.952 575.836 304.044 575.901C296.966 576.409 289.728 577.558 282.745 577.694C280.305 577.741 277.738 577.677 275.524 576.895C269.811 574.875 276.774 572.226 279.039 571.055C281.418 569.825 283.482 568.667 286.022 567.637C289.243 566.332 292.341 564.721 295.258 562.832C299.333 563.735 303.527 564.101 307.697 563.918C309.836 563.824 313.018 574.688 309.91 575.595Z",
    fill: "#161111"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M340.958 349.624C340.427 342.435 339.19 334.673 336.8 327.873",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M299.48 345.125C298.437 339.394 297.392 333.663 296.348 327.932",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M321.487 443.809C322.34 432.636 323.195 421.462 324.049 410.288",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M307.37 287.262C308.231 287.125 309.146 287.385 309.808 287.953C310.469 288.52 310.865 289.386 310.861 290.258",
    fill: "#EBEBEB"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M307.37 287.262C308.231 287.125 309.146 287.385 309.808 287.953C310.469 288.52 310.865 289.386 310.861 290.258",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M376.923 271.934C376.923 276.1 373.546 279.477 369.381 279.477C365.215 279.477 361.838 276.1 361.838 271.934C361.838 267.769 365.215 264.392 369.381 264.392C373.546 264.392 376.923 267.769 376.923 271.934Z",
    fill: "#343434"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M454.283 266.133H388.407V269.168H454.283V266.133Z",
    fill: "#343434"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M454.283 272.961H388.407V275.996H454.283V272.961Z",
    fill: "#343434"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M370.107 274.389C369.573 274.389 369.096 274.297 368.677 274.113C368.261 273.93 367.931 273.675 367.685 273.348C367.442 273.018 367.309 272.636 367.288 272.201H368.309C368.33 272.469 368.422 272.7 368.584 272.894C368.746 273.086 368.958 273.234 369.22 273.34C369.482 273.445 369.772 273.498 370.091 273.498C370.448 273.498 370.764 273.436 371.039 273.311C371.314 273.187 371.53 273.014 371.687 272.793C371.844 272.571 371.922 272.315 371.922 272.023C371.922 271.718 371.846 271.449 371.695 271.217C371.544 270.982 371.323 270.798 371.031 270.666C370.739 270.534 370.383 270.468 369.961 270.468H369.297V269.576H369.961C370.291 269.576 370.58 269.517 370.828 269.398C371.079 269.279 371.275 269.112 371.416 268.896C371.559 268.68 371.63 268.426 371.63 268.134C371.63 267.853 371.568 267.609 371.444 267.401C371.32 267.193 371.144 267.031 370.917 266.915C370.693 266.799 370.429 266.741 370.123 266.741C369.837 266.741 369.567 266.793 369.313 266.899C369.062 267.001 368.857 267.151 368.698 267.348C368.538 267.543 368.452 267.778 368.438 268.053H367.466C367.482 267.618 367.613 267.238 367.859 266.911C368.105 266.581 368.426 266.325 368.823 266.141C369.223 265.958 369.662 265.866 370.14 265.866C370.653 265.866 371.093 265.97 371.46 266.178C371.828 266.383 372.11 266.654 372.307 266.992C372.504 267.33 372.603 267.694 372.603 268.086C372.603 268.553 372.48 268.951 372.234 269.281C371.991 269.61 371.66 269.838 371.242 269.965V270.03C371.765 270.117 372.175 270.339 372.469 270.698C372.763 271.055 372.91 271.497 372.91 272.023C372.91 272.474 372.788 272.879 372.542 273.238C372.299 273.595 371.967 273.876 371.545 274.081C371.124 274.286 370.645 274.389 370.107 274.389Z",
    fill: "#AFAFAF"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M417.582 261.55C416.008 261.317 414.381 262.157 412.909 262.761C412.645 262.87 412.343 262.968 412.081 262.851C411.895 262.769 411.771 262.593 411.656 262.426C411.236 261.814 407.836 255.846 407.02 258.118C406.838 258.624 407.054 259.177 407.272 259.669C409.558 264.841 412.433 269.888 416.67 273.633C417.722 274.562 418.852 275.407 419.834 276.41C422.58 279.219 424.029 283.138 426.943 285.773C427.674 286.435 428.621 287.036 429.585 286.83C432.452 286.219 431.164 280.953 430.223 279.34C429.313 277.78 428.025 276.475 427.011 274.98C425.484 272.728 424.616 270.102 423.317 267.71C422.302 265.839 420.783 263.232 418.939 262.061C418.496 261.777 418.042 261.617 417.582 261.55Z",
    fill: "#EBEBEB",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M411.667 262.413C411.936 263.038 412.258 263.641 412.626 264.214L411.667 262.413Z",
    fill: "#EBEBEB"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M411.667 262.413C411.936 263.038 412.258 263.641 412.626 264.214",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M442.351 564.277C440.692 566.268 436.823 565.266 434.636 565.164C432.887 565.084 431.125 565.456 430.389 563.674C429.962 562.642 430.078 561.413 430.2 560.229C430.596 556.367 430.994 552.491 431.917 548.623C432.543 546 433.612 543.118 436.058 541.493C438.577 539.82 441.908 540.113 443.879 541.727C445.849 543.339 446.608 546.005 446.538 548.68C446.469 551.354 445.657 554.079 444.852 556.766C444.215 558.892 443.577 561.02 442.94 563.146C442.805 563.6 442.604 563.973 442.351 564.277Z",
    fill: "#EBEBEB",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M442.97 562.509C442.849 562.504 442.723 562.512 442.607 562.525C438.68 562.917 434.703 562.817 430.8 562.227C430.302 562.153 429.792 562.069 429.299 562.174C428.853 562.268 428.454 562.509 428.06 562.738C424.357 564.895 420.257 566.368 416.027 567.062C413.594 567.461 410.977 567.659 409.022 569.162C408.107 569.865 407.377 571.189 408.046 572.13C408.273 572.45 408.624 572.657 408.975 572.83C412.618 574.631 418.18 574.07 422.136 573.929C428.525 573.702 434.837 574.214 441.156 573.06C441.414 573.013 441.683 572.955 441.89 572.791C442.179 572.563 442.289 572.181 442.379 571.824C442.817 570.091 443.195 568.328 443.436 566.557C443.532 565.859 443.975 563.336 443.504 562.735C443.38 562.574 443.181 562.519 442.97 562.509Z",
    fill: "#161111"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M503.93 561.238C502.633 563.44 498.648 562.915 496.475 563.086C494.737 563.222 493.063 563.814 492.034 562.12C491.438 561.139 491.344 559.892 491.261 558.691C490.994 554.771 490.726 550.837 490.978 546.846C491.149 544.141 491.712 541.119 493.847 539.187C496.046 537.198 499.381 537.077 501.599 538.449C503.815 539.821 505.018 542.398 505.405 545.087C505.792 547.777 505.455 550.607 505.119 553.4C504.853 555.61 504.586 557.821 504.319 560.031C504.263 560.504 504.128 560.902 503.93 561.238Z",
    fill: "#EBEBEB",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M504.851 559.598C504.758 559.165 492.503 561.152 491.149 561.345C491.099 561.387 491.05 561.43 490.999 561.472C486.726 565.013 481.339 566.902 476.068 568.735C475.253 569.019 474.403 569.326 473.837 569.973C471.42 572.738 476.463 574.003 478.254 574.176C481.187 574.458 484.1 573.902 486.951 573.437C492.853 572.474 498.859 572.884 504.705 571.517C504.936 571.463 505.184 571.397 505.325 571.208C505.436 571.059 505.46 570.861 505.479 570.672C505.843 567.006 505.629 563.254 504.851 559.598Z",
    fill: "#161111"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M502.199 287.621C502.494 284.434 501.473 281.218 499.533 278.671C497.941 276.581 496.463 273.616 493.772 272.75C488.572 271.077 483.64 270.788 480.321 275.591C479.23 277.169 478.783 279.096 478.456 280.987C477.705 285.309 476.481 292.253 479.253 296.18C479.832 297 480.826 297.59 481.8 297.56C482.256 297.546 482.657 297.896 482.754 298.342C483.776 302.962 482.993 307.568 482.186 312.188C481.728 314.806 481.719 317.799 483.507 319.766C484.773 321.158 486.733 321.751 488.615 321.76C491.355 321.772 493.923 320.652 496.595 320.276C499.12 319.921 498.971 318.306 499.033 316.251C499.11 313.717 499.045 311.184 499 308.65C498.912 303.756 498.899 298.762 500.379 294.044C500.928 292.295 501.676 290.601 502.031 288.802C502.106 288.409 502.163 288.015 502.199 287.621Z",
    fill: "#EBEBEB",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M510.6 453.916C510.235 450.581 510.061 447.12 509.987 443.576C509.549 422.479 512.665 398.443 500.221 380.478C497.078 375.941 491.88 372.425 486.548 372.776C482.647 373.032 479.618 375.116 477.338 378.129C476.841 378.787 476.406 379.54 476.015 380.358C462.814 379.903 457.169 393.793 454.352 404.747C448.156 428.839 443.025 453.205 438.974 477.751C436.958 489.959 434.709 502.131 433.015 514.391C431.259 526.975 430.248 540.25 429.48 552.87C429.464 553.125 429.454 553.401 429.599 553.611C429.763 553.848 430.07 553.926 430.351 553.986C435.583 555.106 440.921 555.742 446.27 555.884C446.521 555.89 446.786 555.893 447.004 555.767C447.25 555.624 447.382 555.349 447.498 555.089C452.874 542.974 456.04 529.354 458.689 516.384C463.481 492.925 470.05 469.83 478.313 447.358C479.017 452.668 479.671 457.992 480.143 463.369C482.728 492.834 485.531 522.289 488.535 551.732C495.425 552.411 502.179 552.044 508.891 550.992C513.678 519.062 514.156 486.409 510.6 453.916Z",
    fill: "#0D0D0D",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M510.417 322.643C508.443 315.879 504.423 310.16 496.842 307.889C488.479 305.382 480.733 307.555 476.439 315.321C472.111 323.149 470.116 332.015 468.17 340.746C463.611 361.205 457.635 381.869 454.443 402.572C454.293 403.542 507 403.347 512.167 402.623C512.648 402.556 513.173 402.466 513.492 402.099C513.849 401.689 513.824 401.082 513.78 400.539C512.226 381.35 509.903 363.029 511.715 343.623C512.319 337.183 512.387 329.392 510.417 322.643Z",
    fill: "var(--color-ternary)",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M433.887 417.665C433.765 417.923 433.651 418.19 433.546 418.469C432.682 420.778 431.814 423.229 429.989 424.975C429.237 425.695 428.243 426.281 427.21 426.155C426.191 426.032 425.371 425.244 424.809 424.382C421.669 419.565 425.086 413.874 427.668 409.708C430.54 405.074 434.148 400.791 438.697 397.725C440.591 396.449 442.622 395.195 444.695 394.23C444.913 394.129 445.157 394.029 445.386 394.103C445.649 394.187 445.789 394.47 445.871 394.734C446.3 396.125 445.851 397.649 445.138 398.918C443.452 401.919 440.352 404.006 438.99 407.167C438.263 408.856 438.078 410.757 437.209 412.376C436.171 414.311 434.804 415.732 433.887 417.665Z",
    fill: "#EBEBEB",
    stroke: "#212121",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M484.663 313.39C471.228 306.808 460.176 296.232 449.076 286.154C447.118 284.376 444.376 281.759 441.306 279.33C434.221 273.72 425.395 269.102 420.451 278.076C418.685 281.281 418.796 285.618 420.543 288.824C424.535 296.15 432.217 302.322 438.123 308.087C448.847 318.556 460.727 329.474 474.977 334.683C477.575 327.305 480.723 320.14 484.663 313.39Z",
    fill: "var(--color-ternary)",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M482.978 308.703C481.095 309.633 479.415 311.128 478.03 312.693C476.95 313.914 476.045 315.281 475.256 316.705C470.071 326.063 469.284 335.778 463.506 344.886C456.15 356.48 448.801 368.078 441.448 379.675C438.358 384.548 435.19 389.634 434.497 395.363C433.805 401.092 436.364 407.651 441.772 409.664C445.962 411.224 450.801 409.682 454.285 406.88C457.768 404.077 460.168 400.183 462.5 396.368C469.77 384.474 478.299 372.861 485.125 360.902C490.82 350.925 496.122 335.657 496.902 324.142",
    fill: "var(--color-ternary)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M482.978 308.703C481.095 309.633 479.415 311.128 478.03 312.693C476.95 313.914 476.045 315.281 475.256 316.705C470.071 326.063 469.284 335.778 463.506 344.886C456.15 356.48 448.801 368.078 441.448 379.675C438.358 384.548 435.19 389.634 434.497 395.363C433.805 401.092 436.364 407.651 441.772 409.664C445.962 411.224 450.801 409.682 454.285 406.88C457.768 404.077 460.168 400.183 462.5 396.368C469.77 384.474 478.299 372.861 485.125 360.902C490.82 350.925 496.122 335.657 496.902 324.142",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M495.224 270.822C491.884 269.66 488.263 269.161 485.509 269.244C484.659 269.269 483.667 269.279 483.137 268.613C482.933 268.357 482.833 268.032 482.639 267.766C481.552 266.275 479.255 267.539 478.588 268.797C477.966 269.969 477.815 272.233 477.993 273.52C478.451 276.857 481.736 278.082 484.554 279.015C486.445 279.641 488.672 281.439 489.493 283.268C491.763 288.33 492.203 293.272 497.724 296.282C498.331 296.613 499.049 296.902 499.696 296.658C500.243 296.452 500.589 295.916 500.874 295.405C503.706 290.326 506.404 282.933 503.745 277.274C502.312 274.23 498.943 272.116 495.224 270.822Z",
    fill: "#161111"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M489.482 284.534C490.236 283.615 491.677 283.313 492.772 283.713C493.525 283.988 494.155 284.554 494.572 285.238C495.524 286.798 495.266 289.014 493.932 290.263C492.598 291.511 490.311 291.598 488.93 290.401",
    fill: "#EBEBEB"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M489.482 284.534C490.236 283.615 491.677 283.313 492.772 283.713C493.525 283.988 494.155 284.554 494.572 285.238C495.524 286.798 495.266 289.014 493.932 290.263C492.598 291.511 490.311 291.598 488.93 290.401",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M478.312 447.357C485.554 434.133 490.032 423.695 495.667 409.711",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_1_1305",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 477,
    y: 271,
    width: 26,
    height: 51
  }, _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M502.199 287.621C502.494 284.433 501.473 281.218 499.533 278.671C497.941 276.581 496.463 273.616 493.772 272.75C491.141 271.903 488.206 271.529 485.455 271.843C482.535 272.176 481.391 272.715 480.153 275.471C477.788 280.736 477.674 286.951 478.202 292.606C478.318 293.857 478.528 295.154 479.253 296.18C479.935 297.147 481.22 298.005 482.344 297.717C482.458 297.688 482.575 297.747 482.605 297.86C483.881 302.714 483.035 307.329 482.186 312.188C481.728 314.806 481.719 317.799 483.507 319.765C484.773 321.158 486.733 321.751 488.615 321.76C491.356 321.772 493.923 320.652 496.595 320.276C499.12 319.921 498.971 318.306 499.033 316.251C499.11 313.717 499.046 311.184 499 308.65C498.912 303.756 498.899 298.762 500.379 294.044C500.928 292.295 501.676 290.601 502.031 288.802C502.106 288.409 502.163 288.015 502.199 287.621Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_1_1305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M480.581 297.669C483.535 297.034 486.197 296.701 488.642 295.277C486.708 298.001 483.982 300.156 480.886 301.408",
    fill: "#161111"
  }))), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M543.17 567.367H112.413",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_1_1305",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 423,
    y: 394,
    width: 24,
    height: 33
  }, _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M433.887 417.665C433.765 417.923 433.65 418.19 433.546 418.469C432.681 420.778 431.813 423.229 429.988 424.975C429.236 425.695 428.243 426.281 427.21 426.155C426.19 426.032 425.371 425.244 424.809 424.382C421.668 419.565 425.086 413.874 427.667 409.708C430.54 405.074 434.148 400.791 438.696 397.725C440.59 396.449 442.622 395.195 444.694 394.23C444.912 394.129 445.156 394.029 445.385 394.103C445.648 394.187 445.789 394.47 445.87 394.734C446.299 396.125 445.85 397.649 445.138 398.918C443.451 401.919 440.352 404.006 438.99 407.167C438.263 408.856 438.078 410.757 437.209 412.376C436.17 414.311 434.803 415.732 433.887 417.665Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_1_1305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M432.143 417.094C429.864 420.652 428.557 424.828 428.401 429.052",
    stroke: "#212121",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_1_1305",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 423,
    y: 394,
    width: 24,
    height: 33
  }, _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M433.887 417.665C433.765 417.923 433.65 418.19 433.546 418.469C432.681 420.778 431.813 423.229 429.988 424.975C429.236 425.695 428.243 426.281 427.21 426.155C426.19 426.032 425.371 425.244 424.809 424.382C421.668 419.565 425.086 413.874 427.667 409.708C430.54 405.074 434.148 400.791 438.696 397.725C440.59 396.449 442.622 395.195 444.694 394.23C444.912 394.129 445.156 394.029 445.385 394.103C445.648 394.187 445.789 394.47 445.87 394.734C446.299 396.125 445.85 397.649 445.138 398.918C443.451 401.919 440.352 404.006 438.99 407.167C438.263 408.856 438.078 410.757 437.209 412.376C436.17 414.311 434.803 415.732 433.887 417.665Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_1_1305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M430.35 415.205C427.811 419.437 426.391 424.332 426.271 429.265",
    stroke: "#212121",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_1_1305",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 423,
    y: 394,
    width: 24,
    height: 33
  }, _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M433.887 417.665C433.765 417.923 433.65 418.19 433.546 418.469C432.681 420.778 431.813 423.229 429.988 424.975C429.236 425.695 428.243 426.281 427.21 426.155C426.19 426.032 425.371 425.244 424.809 424.382C421.668 419.565 425.086 413.874 427.667 409.708C430.54 405.074 434.148 400.791 438.696 397.725C440.59 396.449 442.622 395.195 444.694 394.23C444.912 394.129 445.156 394.029 445.385 394.103C445.648 394.187 445.789 394.47 445.87 394.734C446.299 396.125 445.85 397.649 445.138 398.918C443.451 401.919 440.352 404.006 438.99 407.167C438.263 408.856 438.078 410.757 437.209 412.376C436.17 414.311 434.803 415.732 433.887 417.665Z",
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_1_1305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M428.243 413.971C425.535 418.26 424.1 423.342 424.166 428.414",
    stroke: "#212121",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_1305",
    x1: 635,
    y1: 669.881,
    x2: 677.838,
    y2: 644.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--color-second)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E73636"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_1305",
    x1: 377.251,
    y1: 241.562,
    x2: 358.627,
    y2: 236.595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--color-second)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E73636"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_1305",
    x1: 422.391,
    y1: 243.609,
    x2: 404.675,
    y2: 237.301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--color-second)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E73636"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdeaavatar);
export default __webpack_public_path__ + "static/media/IDEAAVATAR.b056d04ebb7a8a326dc39f54ee622677.svg";
export { ForwardRef as ReactComponent };